"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHAT_MEMBERS_FIELD = void 0;
exports.ChatMembersSelector = ChatMembersSelector;
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const BussinesObjectSelectors_1 = require("../../../View/Modals/CommonFormComponents/BussinesObjectSelectors");
exports.CHAT_MEMBERS_FIELD = "_chatSpacePersons";
function ChatMembersSelector() {
    return (react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mt-2", controlId: `${exports.CHAT_MEMBERS_FIELD}-asyncTypeahead` },
        react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Osoby do zaproszenia"),
        react_1.default.createElement(BussinesObjectSelectors_1.PersonSelector, { name: exports.CHAT_MEMBERS_FIELD, multiple: true, showValidationInfo: false }),
        react_1.default.createElement(react_bootstrap_1.Form.Text, null, "Wyszukaj i wybierz do 50 os\u00F3b. Zaproszenia trafi\u0105 na adresy ich aktywnych kont Google w PS.")));
}
